import { useEffect, useRef, useState } from "react";
import { ShipmentType } from "entities/shared/shipmentCard.types";
import { searchFilterStore } from "entities/SearchFilter/model/searchFilter.store";
import { useAppDispatch, useAppSelector } from "shared/lib/redux";
import { capitalize } from "shared/lib/string.lib";
import { ValueOf } from "shared/lib/typeCheck.lib";

import { getInitialSearchQPM } from "../ParamsManager";

type UseSearchTypeParamHandlerReturnType = {
  isSearchTypeParamInitialized: boolean;
};

export const useSearchTypeParamHandler = (): UseSearchTypeParamHandlerReturnType => {
  const dispatch = useAppDispatch();
  const shipment = useAppSelector(searchFilterStore.selectors.shipment);
  const isShipmentTypeConfirmed = useAppSelector(searchFilterStore.selectors.isShipmentTypeConfirmed);
  const allowedShipmentTypes = useAppSelector(searchFilterStore.selectors.allowedShipmentTypes);
  const searchQPM = useRef(getInitialSearchQPM()).current;

  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    if (!allowedShipmentTypes.length) return;

    const searchType = searchQPM.get("shipment-type");
    if (searchType) {
      const isSearchTypeValid = new Set(allowedShipmentTypes).has(capitalize(searchType));
      if (isSearchTypeValid) {
        dispatch(searchFilterStore.actions.setShippingType(capitalize<ValueOf<typeof ShipmentType>>(searchType)));
      } else if (isShipmentTypeConfirmed) {
        searchQPM.set("shipment-type", shipment.toLowerCase());
        searchQPM.update();
      }
    }
    setIsInitialized(true);
  }, [allowedShipmentTypes]);

  useEffect(() => {
    if (!isInitialized || !isShipmentTypeConfirmed) return;

    const searchType = searchQPM.get("shipment-type");
    if (searchType && shipment === capitalize<ValueOf<typeof ShipmentType>>(searchType)) return;

    searchQPM.set("shipment-type", shipment.toLowerCase());
    searchQPM.update();
  }, [shipment, isShipmentTypeConfirmed, isInitialized]);

  return {
    isSearchTypeParamInitialized: isInitialized,
  };
};
